import { Component } from 'react';
import AuthApis from '../../hepler/authApis.service';
import { postMessage } from '../../utils/common.utils';
import ConsentRenewRedirectionCard from './ConsentRenewRedirectionCard';
import { withTranslation } from '../../hoc/withTranslation';

class ConsentRenewStatus extends Component {
	constructor(props) {
		super(props);
		this.state = {
			time: global.redirectTimer || 5,
			isCloseWindow: false,
			sessionError: false,
		};
		this.authApis = new AuthApis();
	}

	async componentDidMount() {
		const isInvalidParams =
			this.props?.location?.state?.status === 'Invalid parameters';

		if (isInvalidParams) {
			this.handleInvalidParams();
		} else if (global.isRedirect === 'true') {
			await this.redirect();
		} else {
			await this.logout();
		}
	}

	handleInvalidParams = () => {
		postMessage('exit', 'INVALID_PARAMS');
		if (global.isRedirect === 'true' && global.redirectUrl) {
			this.id = setInterval(() => {
				this.setState((prevState) => {
					const newTime = prevState.time - 1;
					if (newTime <= 0) {
						clearInterval(this.id);
						if (global.redirectUrl.includes('?')) {
							global.sendBackBtnRes
								? window.location.replace(
										global.redirectUrl +
											'&ecres=' +
											global.encryptedres +
											'&resdate=' +
											global.resDate +
											'&fi=' +
											global.encryptedFiId
								  )
								: window.location.replace(global.redirectUrl);
						} else {
							global.sendBackBtnRes
								? window.location.replace(
										global.redirectUrl +
											'?ecres=' +
											global.encryptedres +
											'&resdate=' +
											global.resDate +
											'&fi=' +
											global.encryptedFiId
								  )
								: window.location.replace(global.redirectUrl);
						}
						return { time: 0 };
					}
					return { time: newTime };
				});
			}, 1000);
		} else {
			this.setState({ isCloseWindow: true });
		}
	};

	startTimer = (payload) => {
		this.id = setInterval(() => {
			this.setState((prevState, prevProps) => ({
				time: prevState.time - 1,
			}));
			if (this.state.time === 0) {
				clearInterval(this.id);
				this.setState({ time: 0 });
				if (payload['redirectUrl'].includes('?')) {
					window.location.replace(
						payload['redirectUrl'] +
							'&ecres=' +
							payload['encryptedResponse'] +
							'&resdate=' +
							payload['responseDate'] +
							'&fi=' +
							payload['encryptedFiId']
					);
				} else {
					window.location.replace(
						payload['redirectUrl'] +
							'?ecres=' +
							payload['encryptedResponse'] +
							'&resdate=' +
							payload['responseDate'] +
							'&fi=' +
							payload['encryptedFiId']
					);
				}
				if (this.props?.location?.state?.statusCode === 200) {
					postMessage('consent', 'ACCEPT');
				} else {
					postMessage('consent', 'DENY');
				}
			}
		}, 1000);
	};

	logout = async () => {
		this.authApis.logout(global.userId).then((res) => {
			if (res?.status === 'SUCCESS') {
				if (this.props?.location?.state?.statusCode === 200) {
					postMessage('consent', 'ACCEPT');
				} else {
					postMessage('consent', 'DENY');
				}
			}
		});
	};

	redirect = () => {
		let status = this.props?.location?.state?.statusCode;
		let code =
			status === 200 ? 0 : status === 201 ? 1 : status === 202 ? 20 : status;
		if (this.authApis.getSID() === '') {
			this.setState({ isCloseWindow: true });
			return;
		}
		this.authApis.encryptRequest(code).then((res) => {
			let payload = res?.payload;
			this.authApis.logout(global.userId).then(async (res) => {
				if (res?.status === 'SUCCESS') {
					if (this.props?.location?.state?.statusCode === 200) {
						postMessage('consent', 'ACCEPT');
					} else if (this.props?.location?.state?.statusCode === 201) {
						postMessage('consent', 'DENY');
					}
					if (payload['redirectUrl'] && payload['redirectUrl'] !== 'none') {
						this.startTimer(payload);
					} else {
						this.setState({ isCloseWindow: true });
					}
				} else {
					this.setState({ isCloseWindow: true });
				}
			});
		});
	};

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			if (this.props.history.action === 'POP') {
				window.confirm(this.props.t('login.messages.confirmBack'));
			}
		}
	}

	componentWillUnmount() {
		if (this.id) {
			clearInterval(this.id);
		}
	}

	render() {
		return (
			<ConsentRenewRedirectionCard
				statusCode={this.props?.location?.state?.statusCode}
				isCloseWindow={this.state.isCloseWindow}
				sessionError={this.state.sessionError}
				time={this.state.time}
				fiuName={global.entityName}
				transactionId={this.props?.location?.state?.transactionId}
				customDetails={this.props.customDetails}
			/>
		);
	}
}

export default withTranslation(ConsentRenewStatus);
